require('./bootstrap');


//import * as Sentry from "@sentry/browser";

window.Sentry = require('@sentry/browser');

import { BrowserTracing } from "@sentry/tracing";

Sentry.init({
    dsn: "https://908e0bebce904b66a6afb3fa1211d585@o1133159.ingest.sentry.io/6261328",
    integrations: [new BrowserTracing()],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0,
});
